import { render } from "./update_v2.vue?vue&type=template&id=29b3b62a&scoped=true"
import script from "./update_v2.vue?vue&type=script&lang=js"
export * from "./update_v2.vue?vue&type=script&lang=js"

import "./update_v2.vue?vue&type=style&index=0&id=29b3b62a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/santo_cartao_adm_master/santo_cartao_adm_master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29b3b62a"]])

export default __exports__